import React, { useEffect, useState } from "react"
import Project from './Project'
import RecentProject from './RecentProject'
import ProjectsFilterButtons from './ProjectsFilterButtons'
import { useGeneral } from "../../../context/general"
import { Skeleton, Typography, Grid, useMediaQuery, Pagination, Paper } from '@mui/material'
import './Projects.css'
import styles from './RecentProject.module.scss'

function GridItem(props) {
    return (
        <Grid item xs={12} sm={6} md={4} lg={3} {...props}>
            {props.children}
        </Grid>
    )
}

export default function Projects({ variant = 'watchlist' }) {
    const { watchlistProjects, projects, handleCreateProjectAndOpen } = useGeneral()
    const [filteredProjects, setFilteredProjects] = useState([])
    const [paginationPointer, setPaginationPointer] = useState(0)

    useEffect(() => {    
        setPaginationPointer(0)
        return () => {}
    }, [filteredProjects] )

    // Decide how many columns to display
    const col4 = useMediaQuery(theme => (theme.breakpoints.up('lg'))) && 4
    const col3 = useMediaQuery(theme => (theme.breakpoints.up('md'))) && 3
    const col2 = useMediaQuery(theme => (theme.breakpoints.up('sm'))) && 2
    const col1 = useMediaQuery(theme => (theme.breakpoints.up('xs'))) && 1
    const numberOfColumns = col4 || col3 || col2 || col1

    const render_message = (text) => (
        <Paper elevation={0} className="projectCard projectCard-cta">
            <Typography variant="h4">{text}</Typography>
        </Paper>
    )

    const pagination = {
        pages: Math.ceil(filteredProjects?.length / (numberOfColumns * 3)),
        perPage: numberOfColumns * 3
    }
    pagination.currentPage = Math.ceil( paginationPointer / pagination.perPage ) + 1
    
    const projectsPagination = (
        <Grid item xs={12} className="projectsPaginationContainer" key="projectsPagination">
            { pagination.pages > 1 && (
                <Pagination
                    count={pagination.pages}
                    page={pagination.currentPage}
                    onChange={(e, val) => setPaginationPointer(((val - 1) * pagination.perPage))}
                />)
            }
        </Grid>
    )

    const renderWatchlistProjects = () => {
        const watchlistProjectsComponent = watchlistProjects
            .filter(project => filteredProjects.includes(project.uuid))
            .slice(paginationPointer, paginationPointer + pagination.perPage)
            .map((project) => (
                <GridItem key={project.uuid}>
                    <Project {...project} handleCreateProjectAndOpen={handleCreateProjectAndOpen}/>
                </GridItem>
            ))
        return watchlistProjectsComponent.length > 0
            ? [...watchlistProjectsComponent, projectsPagination]
            : (<GridItem key='no-projects'>{render_message('No projects found')}</GridItem>)
    }
    

    const renderRecentsProjects = () => {
        const recentProjects = projects
            .slice(0, 5)
            .map((project) => (<RecentProject {...project} handleCreateProjectAndOpen={handleCreateProjectAndOpen} key={project.uuid}/>))
        return recentProjects.length > 0
            ? recentProjects
            : render_message('No projects yet')
    }

    const renderSkeleton = () => (
        <Grid item xs={12}>
            <Skeleton variant="rect" width="300px" height="350px" />
        </Grid>
    )

    return (
        <>
            { variant === 'watchlist' && (<>
                <ProjectsFilterButtons
                    projects={watchlistProjects}
                    filters={[
                        { label: 'Stock', key: 'stock' },
                        { label: 'Sector', key: 'sector' },
                    ]}
                    setFilteredProjects={setFilteredProjects}
                />
            
            <Grid container spacing={3} className='projectsContainer'>
                { !projects ? renderSkeleton() : renderWatchlistProjects() }
            </Grid></>)}
            {variant === 'recent' && 
            <Paper className={styles['projectsRecent-container']}>
                { !projects ? renderSkeleton() : renderRecentsProjects() }
            </Paper>}
        </>
    )
}